import { useState } from "react";
import { useRouter } from "next/router";
import ResponsievLine from "../assets/ResponsievLine";
import Line from "../assets/Line";
import PlayButton from "../about_us/PlayButton";
function Play_button() {
  const router = useRouter();

  return (
    <div className="relative mt-[50px] mds:mt-0">
      <div className="overflow-hidden 	sm:flex justify-center lg:pt-[40px] pt-[20px] ">
        <ResponsievLine />
        <Line />
      </div>
      <div className="absolute sm:top-[180px] mds:top-[90px] top-10 bg-red-600 w-[60%] xl:max-w-[65rem]">
        <div
          className={`absolute   ${
            router.locale == "ar"
              ? "right-[100%] lg:top-[70px] top-[30px]"
              : "left-[100%]"
          }  top-[70px] h-[200px]`}
        >
          <PlayButton />
        </div>
      </div>
    </div>
  );
}

export default Play_button;
